export interface IEquityMovementScheduleDates {
    // Closing dates are the BALANCE SHEET dates, opening dates the start of the income period.
    currentYearClosingDate: string;
    // optional incase of no previous data  is available
    currentYearOpeningDate?: string; // which is also 'previousYearClosingDate'
    previousYearOpeningDate: string;
    previousYearClosingDate?: string;
    // False for quarterly or shortened periods; decides whether the header reads
    // "Geschäftsjahr <year>" or spells the period out.
    currentPeriodIsFullYear?: boolean;
    previousPeriodIsFullYear?: boolean;
}
